import styled, { css } from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';

const Footer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  a {
    color: ${color.highempahis};
    text-decoration: none;
    margin: 8px 4px;
  }
`;

const Wrapper = styled.div`
  background-color: ${color.whiteSmoke};
  padding: 10px;
  min-height: 100vh;

  @media ${device.tablet} {
    padding: 20px 0;
  }
`;

interface HeaderContainerProps {
  isGuestCompanyStock?: boolean;
}

const HeaderContainer = styled.div<HeaderContainerProps>`
  ${({ isGuestCompanyStock }) => {
    if (isGuestCompanyStock) {
      return css`
        background-color: ${color.light};

        @media ${device.tablet} {
          border-bottom: 1px solid ${color.gainsboro};
        }
      `;
    }
    return css``;
  }}
`;

const HeaderFlex = styled(Flex)`
  max-width: 930px;
  ${(props) => {
    // @ts-expect-error
    if (props.isGuestCompanyStock) {
      return css`
        height: 72px;
        padding: 22px 20px;

        img {
          height: 40px;
          width: 75px;
        }
        button {
          width: 99px;
          height: 28px;
        }
        button.button-login p,
        button.button-register p {
          font-size: 12px;
        }

        @media ${device.laptop} {
          padding: 20px 10px;
        }
      `;
    }
    return css`
      padding: 20px 10px;

      img {
        height: 40px;
      }
    `;
  }}
`;

const MainContainer = styled(Flex)`
  max-width: 930px;
  ${(props) => {
    // @ts-expect-error
    if (props.isGuestCompanyStock) {
      return css`
        padding: 0;

        @media ${device.tablet} {
          padding: 20px 30px;
        }

        @media ${device.laptop} {
          padding: 20px 10px;
        }
      `;
    }

    return css``;
  }}
`;

export { Footer, Wrapper, HeaderContainer, HeaderFlex, MainContainer };
